"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { Tooltip } from '../Tooltip/index.mjs';

function FieldDescription({ text }) {
  if (!text) return null;
  return /* @__PURE__ */ jsx(Tooltip, { tooltip: text, offset: [0, 4], placement: "bottom-start", usePortal: true, children: /* @__PURE__ */ jsx("span", { className: "inline-block min-w-5 cursor-help rounded-sm bg-neutral-2 px-1 ml-2 text-center leading-[1.2] text-neutral-11 hover:bg-neutral-3", children: "?" }) });
}

export { FieldDescription };
